import { Image as T } from "@allmaps/iiif-parser";
import { GcpTransformer as c } from "@allmaps/transform";
import { lonLatToWebMecator as M, bboxToRectangle as p, computeBbox as t, rectanglesToScale as d, getPropertyFromCacheOrComputation as u, mixPoints as g, fetchImageInfo as k } from "@allmaps/stdlib";
import { applyTransform as s } from "../shared/matrix.js";
import { WarpedMapEvent as F, WarpedMapEventType as j } from "../shared/events.js";
const h = {
  minOffsetRatio: 0.01,
  minOffsetDistance: 4,
  maxDepth: 4,
  differentHandedness: !0
}, f = !0;
function G() {
  return {
    visible: f
  };
}
function x() {
  return (l, e, r) => new w(l, e, r);
}
class w extends EventTarget {
  mapId;
  georeferencedMap;
  gcps;
  projectedGcps;
  projectedGeoPoints;
  projectedGeoPreviousTransformedResourcePoints;
  projectedGeoTransformedResourcePoints;
  resourcePreviousMask;
  resourceMask;
  resourceMaskBbox;
  resourceMaskRectangle;
  resourceFullMask;
  resourceFullMaskBbox;
  resourceFullMaskRectangle;
  imageInformations;
  parsedImage;
  loadingImageInfo;
  fetchFn;
  abortController;
  visible;
  mixed = !1;
  previousTransformationType;
  transformationType;
  transformer;
  projectedPreviousTransformer;
  projectedTransformer;
  transformerByTransformationType = /* @__PURE__ */ new Map();
  projectedTransformerByTransformationType = /* @__PURE__ */ new Map();
  geoMask;
  geoMaskBbox;
  geoMaskRectangle;
  geoFullMask;
  geoFullMaskBbox;
  geoFullMaskRectangle;
  projectedGeoMask;
  projectedGeoMaskBbox;
  projectedGeoMaskRectangle;
  projectedGeoFullMask;
  projectedGeoFullMaskBbox;
  projectedGeoFullMaskRectangle;
  resourceToProjectedGeoScale;
  previousDistortionMeasure;
  distortionMeasure;
  tileZoomLevelForViewport;
  overviewTileZoomLevelForViewport;
  projectedGeoBufferedViewportRectangleForViewport;
  projectedGeoBufferedViewportRectangleBboxForViewport;
  resourceBufferedViewportRingForViewport;
  resourceBufferedViewportRingBboxForViewport;
  fetchableTilesForViewport = [];
  overviewFetchableTilesForViewport = [];
  /**
   * Creates an instance of WarpedMap.
   *
   * @constructor
   * @param {string} mapId - ID of the map
   * @param {GeoreferencedMap} georeferencedMap - Georeferenced map used to construct the WarpedMap
   * @param {WarpedMapOptions} [options] - options
   */
  constructor(e, r, o) {
    super(), o = {
      ...G(),
      ...o
    }, this.mapId = e, this.georeferencedMap = r, this.gcps = this.georeferencedMap.gcps, this.projectedGcps = this.gcps.map(({ resource: n, geo: m }) => ({
      resource: n,
      geo: M(m)
    })), this.projectedGeoPoints = this.projectedGcps.map(
      (n) => n.geo
    ), this.resourceMask = this.georeferencedMap.resourceMask, this.updateResourceMaskProperties();
    const i = this.georeferencedMap.resource.width, a = this.georeferencedMap.resource.height;
    i && a ? this.resourceFullMask = [
      [0, 0],
      [i, 0],
      [i, a],
      [0, a]
    ] : this.resourceFullMask = p(this.resourceMaskBbox), this.resourceFullMaskBbox = t(this.resourceFullMask), this.resourceFullMaskRectangle = p(this.resourceFullMaskBbox), this.imageInformations = o.imageInformations, this.loadingImageInfo = !1, this.visible = o.visible || f, this.fetchFn = o.fetchFn, this.transformationType = o.transformation?.type || this.georeferencedMap.transformation?.type || "polynomial", this.previousTransformationType = this.transformationType, this.updateTransformerProperties();
  }
  /**
   * Get resourceMask in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Ring}
   */
  getViewportMask(e) {
    return this.projectedGeoMask.map((r) => s(e.projectedGeoToViewportTransform, r));
  }
  /**
   * Get Bbox of resourceMask in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Bbox}
   */
  getViewportMaskBbox(e) {
    return t(this.getViewportMask(e));
  }
  /**
   * Get resourceMaskRectangle in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Rectangle}
   */
  getViewportMaskRectangle(e) {
    return this.projectedGeoMaskRectangle.map((r) => s(e.projectedGeoToViewportTransform, r));
  }
  /**
   * Get resourceFullMask in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Ring}
   */
  getViewportFullMask(e) {
    return this.projectedGeoFullMask.map((r) => s(e.projectedGeoToViewportTransform, r));
  }
  /**
   * Get bbox of rresourceFullMask in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Bbox}
   */
  getViewportFullMaskBbox(e) {
    return t(this.getViewportFullMask(e));
  }
  /**
   * Get resourceFullMaskRectangle in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Rectangle}
   */
  getViewportFullMaskRectangle(e) {
    return this.projectedGeoFullMaskRectangle.map((r) => s(e.projectedGeoToViewportTransform, r));
  }
  /**
   * Get scale of the warped map, in resource pixels per viewport pixels.
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {number}
   */
  getResourceToViewportScale(e) {
    return d(
      this.resourceMaskRectangle,
      this.getViewportMaskRectangle(e)
    );
  }
  /**
   * Get scale of the warped map, in resource pixels per canvas pixels.
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {number}
   */
  getResourceToCanvasScale(e) {
    return this.getResourceToViewportScale(e) / e.devicePixelRatio;
  }
  /**
   * Get the reference scaling from the forward transformation of the projected Helmert transformer
   *
   * @returns {number}
   */
  getReferenceScale() {
    const e = u(
      this.projectedTransformerByTransformationType,
      "helmert",
      () => new c(this.projectedGcps, "helmert", h)
    );
    return e.forwardTransformation || e.createForwardTransformation(), e.forwardTransformation.scale;
  }
  /**
   * Update the resourceMask loaded from a georeferenced map to a new mask.
   *
   * @param {Ring} resourceMask
   */
  setResourceMask(e) {
    this.resourceMask = e, this.updateResourceMaskProperties(), this.updateGeoMask(), this.updateProjectedGeoMask(), this.updateResourceToProjectedGeoScale();
  }
  /**
   * Set the transformationType
   *
   * @param {TransformationType} transformationType
   */
  setTransformationType(e) {
    this.transformationType = e, this.updateTransformerProperties();
  }
  /**
   * Set the distortionMeasure
   *
   * @param {DistortionMeasure} [distortionMeasure] - the disortion measure
   */
  setDistortionMeasure(e) {
    this.distortionMeasure = e, this.updateDistortionProperties();
  }
  /**
   * Update the Ground Controle Points loaded from a georeferenced map to new Ground Controle Points.
   *
   * @param {Gcp[]} gcps
   */
  setGcps(e) {
    this.gcps = e, this.updateTransformerProperties(!1);
  }
  /**
   * Set the tile zoom level for the current viewport
   *
   * @param {number} [tileZoomLevel] - tile zoom level for the current viewport
   */
  setTileZoomLevelForViewport(e) {
    this.tileZoomLevelForViewport = e;
  }
  /**
   * Set the overview tile zoom level for the current viewport
   *
   * @param {TileZoomLevel} [tileZoomLevel] - tile zoom level for the current viewport
   */
  setOverviewTileZoomLevelForViewport(e) {
    this.overviewTileZoomLevelForViewport = e;
  }
  /**
   * Set projectedGeoBufferedViewportRectangle for the current viewport
   *
   * @param {Rectangle} [projectedGeoBufferedViewportRectangle]
   */
  setProjectedGeoBufferedViewportRectangleForViewport(e) {
    this.projectedGeoBufferedViewportRectangleForViewport = e, this.projectedGeoBufferedViewportRectangleBboxForViewport = e ? t(e) : void 0;
  }
  /**
   * Set resourceBufferedViewportRing for the current viewport
   *
   * @param {Ring} [resourceBufferedViewportRing]
   */
  setResourceBufferedViewportRingForViewport(e) {
    this.resourceBufferedViewportRingForViewport = e, this.resourceBufferedViewportRingBboxForViewport = e ? t(e) : void 0;
  }
  /**
   * Set tiles for the current viewport
   *
   * @param {FetchableTile[]} fetchableTiles
   */
  setFetchableTilesForViewport(e) {
    this.fetchableTilesForViewport = e;
  }
  /**
   * Set overview tiles for the current viewport
   *
   * @param {FetchableTile[]} overviewFetchableTiles
   */
  setOverviewFetchableTilesForViewport(e) {
    this.overviewFetchableTilesForViewport = e;
  }
  /**
   * Reset the properties for the current values
   */
  resetForViewport() {
    this.setTileZoomLevelForViewport(), this.setOverviewTileZoomLevelForViewport(), this.setProjectedGeoBufferedViewportRectangleForViewport(), this.setResourceBufferedViewportRingForViewport(), this.setFetchableTilesForViewport([]), this.setOverviewFetchableTilesForViewport([]);
  }
  /**
   * Reset the properties of the previous and new transformationType.
   */
  resetPrevious() {
    this.mixed = !1, this.previousTransformationType = this.transformationType, this.previousDistortionMeasure = this.distortionMeasure, this.projectedPreviousTransformer = this.projectedTransformer, this.projectedGeoPreviousTransformedResourcePoints = this.projectedGeoTransformedResourcePoints, this.resourcePreviousMask = this.resourceMask;
  }
  /**
   * Mix the properties of the previous and new transformationType.
   *
   * @param {number} t
   */
  mixPreviousAndNew(e) {
    this.mixed = !0, this.previousTransformationType = this.transformationType, this.previousDistortionMeasure = this.distortionMeasure, this.projectedPreviousTransformer = this.projectedTransformer, this.projectedGeoPreviousTransformedResourcePoints = this.projectedGeoTransformedResourcePoints.map((r, o) => g(
      r,
      this.projectedGeoPreviousTransformedResourcePoints[o],
      e
    ));
  }
  /**
   * Check if this instance has image info
   *
   * @returns {this is WarpedMapWithImageInfo}
   */
  hasImageInfo() {
    return this.parsedImage !== void 0;
  }
  /**
   * Fetch and parse the image info, and generate the image ID
   *
   * @async
   * @returns {Promise<void>}
   */
  async loadImageInfo() {
    try {
      this.loadingImageInfo = !0;
      const e = this.georeferencedMap.resource.id;
      let r;
      if (this.imageInformations?.get(e))
        r = this.imageInformations.get(e);
      else {
        this.abortController = new AbortController();
        const o = this.abortController.signal;
        r = await k(e, { signal: o }, this.fetchFn), this.abortController = void 0, this.imageInformations?.set(e, r);
      }
      this.parsedImage = T.parse(r), this.dispatchEvent(new F(j.IMAGEINFOLOADED));
    } catch (e) {
      throw this.loadingImageInfo = !1, e;
    } finally {
      this.loadingImageInfo = !1;
    }
  }
  updateResourceMaskProperties() {
    this.resourceMaskBbox = t(this.resourceMask), this.resourceMaskRectangle = p(this.resourceMaskBbox), this.resourcePreviousMask || (this.resourcePreviousMask = this.resourceMask);
  }
  updateTransformerProperties(e = !0) {
    this.updateTransformer(e), this.updateProjectedTransformer(e), this.updateProjectedGeoTransformedResourcePoints(), this.updateGeoMask(), this.updateFullGeoMask(), this.updateProjectedGeoMask(), this.updateProjectedFullGeoMask(), this.updateResourceToProjectedGeoScale();
  }
  updateTransformer(e = !0) {
    this.transformer = u(
      this.transformerByTransformationType,
      this.transformationType,
      () => new c(
        this.gcps,
        this.transformationType,
        h
      ),
      () => e
    );
  }
  updateProjectedTransformer(e = !0) {
    this.projectedTransformer = u(
      this.projectedTransformerByTransformationType,
      this.transformationType,
      () => new c(
        this.projectedGcps,
        this.transformationType,
        h
      ),
      () => e
    ), this.projectedPreviousTransformer || (this.projectedPreviousTransformer = this.projectedTransformer);
  }
  updateProjectedGeoTransformedResourcePoints() {
    this.projectedGeoTransformedResourcePoints = this.gcps.map(
      (e) => this.projectedTransformer.transformToGeo(e.resource)
    ), this.projectedGeoPreviousTransformedResourcePoints || (this.projectedGeoPreviousTransformedResourcePoints = this.projectedGeoTransformedResourcePoints);
  }
  updateGeoMask() {
    this.geoMask = this.transformer.transformToGeoAsGeojson([this.resourceMask]), this.geoMaskBbox = t(this.geoMask), this.geoMaskRectangle = this.transformer.transformToGeo(
      [this.resourceMaskRectangle],
      { maxDepth: 0 }
    )[0];
  }
  updateFullGeoMask() {
    this.geoFullMask = this.transformer.transformToGeoAsGeojson([
      this.resourceFullMask
    ]), this.geoFullMaskBbox = t(this.geoFullMask), this.geoFullMaskRectangle = this.transformer.transformToGeo(
      [this.resourceFullMaskRectangle],
      { maxDepth: 0 }
    )[0];
  }
  updateProjectedGeoMask() {
    this.projectedGeoMask = this.projectedTransformer.transformToGeo([
      this.resourceMask
    ])[0], this.projectedGeoMaskBbox = t(this.projectedGeoMask), this.projectedGeoMaskRectangle = this.projectedTransformer.transformToGeo(
      [this.resourceMaskRectangle],
      { maxDepth: 0 }
    )[0];
  }
  updateProjectedFullGeoMask() {
    this.projectedGeoFullMask = this.projectedTransformer.transformToGeo([
      this.resourceFullMask
    ])[0], this.projectedGeoFullMaskBbox = t(this.projectedGeoFullMask), this.projectedGeoFullMaskRectangle = this.projectedTransformer.transformToGeo(
      [this.resourceFullMaskRectangle],
      { maxDepth: 0 }
    )[0];
  }
  updateResourceToProjectedGeoScale() {
    this.resourceToProjectedGeoScale = d(
      this.resourceMaskRectangle,
      this.projectedGeoMaskRectangle
    );
  }
  updateDistortionProperties() {
  }
  destroy() {
    this.abortController && this.abortController.abort();
  }
}
export {
  x as createWarpedMapFactory,
  w as default
};
//# sourceMappingURL=WarpedMap.js.map
